import { TabPanel } from '@chakra-ui/react';
import { t } from 'i18next';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import EmptyCase from '../../components/errors/EmptyCase';
import LikedMembersList from '../../components/lists/LikedMembersList';
import WishedPhotoCard from '../../components/photocard/WishedPhotoCard';
import { ReactComponent as ArrowUpShapeIcon } from '../../icons/arrow.up.shape.svg';
import { getMemberIdAnyway } from '@pocapan/shared/utils/etcUtils';
import { queryGet } from '@pocapan/shared/utils/queryClient';

export default function WishPhotoCardsTab({ artist }) {
  const [selectedMember, setSelectedMember] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const { user_id: userId } = useParams();
  const artistId = artist?.artistId;

  const queryParams = new URLSearchParams();
  if (selectedMember && getMemberIdAnyway(selectedMember) !== 'all') {
    queryParams.append('member_id', getMemberIdAnyway(selectedMember));
  }

  const { data: wishedPhotoCards } = useQuery(
    ['wishedPhotoCards', artistId, queryParams.toString()],
    () => queryGet(`/artists/${artistId}/wished_photo_cards?${queryParams}`),
    {
      enabled: !!artistId,
      select: (r) => r.photoCards
    }
  );

  const onChangeLikedMember = (member) => {
    setSelectedMember(member);
  };

  const onToggled = (_photoCard, _wished) => {
    // Nothing todo
  };

  const _navigateMyPhotoCardBoardPage = () => {
    const redirectUrl = encodeURIComponent(`${location.pathname}${location.search}`);
    navigate(`/users/${userId}/binder?redirectUrl=${redirectUrl}`);
  };

  return (
    <TabPanel padding={0}>
      {/* <Center>
        <Box
          marginBottom={'16px'}
          paddingX={'24px'}
          paddingY={'14px'}
          width={'100%'}
          borderRadius={'12px'}
          backgroundImage={'/assets/backgrounds/banner_bg_holography.png'}
        >
          <Wrap justify={'center'} onClick={navigateMyPhotoCardBoardPage}>
            <Text className="text-main-light-1" fontSize={'17px'} fontWeight={600}>
              {t('myWishedPage.createPhotoCardBoard')}
            </Text>
            <ArrowUpShapeIcon className="fill-black" />
          </Wrap>
        </Box>
      </Center> */}
      <LikedMembersList
        artistMembers={artist?.members}
        onChangeLikedMember={(member) => onChangeLikedMember(member)}
        addEntireOption={true}
      />
      <div style={{ marginTop: '12px' }}>
        {wishedPhotoCards &&
          (isEmpty(wishedPhotoCards)
            ? <EmptyCase
                title={t('emptyWishedTradingPhotoCard.title')}
                description={t('emptyWishedTradingPhotoCard.description')}
                emoji={'🙂'}
              />
            : wishedPhotoCards.map((photoCard) => {
                return (
                  <div key={photoCard.photoCardId} style={{ marginBottom: '12px' }}>
                    <WishedPhotoCard photoCard={photoCard} onToggled={onToggled} />
                  </div>
                );
              }))}
      </div>
    </TabPanel>
  );
}
